<template>
    <div id="doctor-clinic-code">
        <div class="row topactionform smallmargin">
            <div class="col-xs-4">
                <div class="smalltitle">Code</div>
                <span v-if="$route.query.type == '1'">Invitation Editor Code</span>
                <span v-if="$route.query.type == '2'">Editor/Clinic</span>
            </div>

            <div class="col-xs-8">
                <form class="onelineform flowsearch">
                    <input type="text" v-model="key_search" placeholder="Enter new code"
                           class="keyinput" style="width: 65% !important;">
                    <button style="width: 15%" class="submit btn light" @click.prevent="loadData"><i
                            class="fa fa-search"></i></button>
                    <button style="width: 20%" class="submit btn light" @click.prevent="showGenerateCode()">Generate codes</button>
                </form>
            </div>
        </div>

        <ul class="itemlisttable flowlisttype messageflow">
            <li class="itemlisthead">
                <div class="item-common">Code</div>
                <div class="item-common">Created At</div>
                <div class="item-common">Used By</div>
                <div class="item-common">First Name</div>
                <div class="item-common">Last Name</div>
                <div class="item-common">Email</div>
                <div class="item-common">Join Date</div>
                <div class="item-common">NPI#</div>
                <div class="item-common">ABAI#</div>
                <div class="item-common">Phone</div>
                <div class="item-taxonomy">Don't check taxonomy</div>
                <div style="text-align: right;">Action</div>
            </li>
            <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt">
                <i class="fas fa-spinner fa-spin"></i>
            </li>
            <li v-if="!isLoading && dataCodes.length === 0" style="text-align: center; font-size: 16pt">No records
                found
            </li>
            <li v-if="!isLoading" v-for="(dataCode, index) in dataCodes">
                <div class="item-common">{{ dataCode.code }}</div>
                <div class="item-common">{{ formatFullTime(dataCode.createdAt) }}</div>
                <div class="item-common">{{ dataCode.fullName }}</div>
                <div class="item-common">{{ dataCode.firstName }}</div>
                <div class="item-common">{{ dataCode.lastName }}</div>
                <div class="item-common">{{ dataCode.email }}</div>
                <div class="item-common">{{ dataCode.email }}</div>
                <div class="item-common">{{ dataCode.npi }}</div>
                <div class="item-common">{{ dataCode.abai }}</div>
                <div class="item-common">{{ dataCode.phoneRecovery }}</div>
                <div class="item-taxonomy">{{ dataCode.do_not_verify_taxonomy ? 'Yes': 'No'}}</div>
                <div style="text-align: right;">
                    <i class="fa fa-trash" @click.prevent="removeItem(dataCode, index)"></i>
                </div>
            </li>
        </ul>
        <br/>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>

        <modal v-model="modalGenerateCode" class="skintestblock" :backdrop="false" size="lg">
            <h4 slot="title" class="smalltitle">Generate codes</h4>
            <div class="modal-body">
                <div class="blockcont">
                    <div class="prolabel">Number of code</div>
                    <div class="profield">
                        <span class="selectwrap">
                             <select v-model="dataGenCode.numberOfCode">
                                 <option value="1">1</option>
                                 <option value="2">2</option>
                                 <option value="3">3</option>
                                 <option value="4">4</option>
                                 <option value="5">5</option>
                                 <option value="6">6</option>
                                 <option value="7">7</option>
                                 <option value="8">8</option>
                                 <option value="9">9</option>
                                 <option value="10">10</option>
                             </select>
                        </span>
                    </div>
                    <div class="prolabel">Expire date</div>
                    <div class="profield">
                        <date-picker v-model="dataGenCode.expirationDate"
                                     placeholder="Expire date" title="Expire date"
                                     format="MM/DD/YYYY"
                                     :clearable="true"
                                     :append-to-body=true
                                     lang="en">
                        </date-picker>
                    </div>
                    <div class="prolabel">Can use many times</div>
                    <div class="profield">
                        <input type="text" v-model="dataGenCode.times">
                    </div>

                    <div class="prolabel">Don't check taxonomy</div>
                    <div class="profield" style="margin-top: 10px !important;">
                        <input type="checkbox" :value="1" v-model="dataGenCode.do_not_verify_taxonomy">
                    </div>

                  <div class="prolabel">Allow sole proprietor sign-up clinic</div>
                  <div class="profield" style="margin-top: 10px !important;">
                    <input type="checkbox" :value="1" v-model="dataGenCode.allow_sole_proprietor_sign_up_clinic">
                  </div>
                </div>
            </div>
            <div slot="footer">
                <button @click.prevent="generateCode()" class="btn btn-default" type="button">
                    Create
                </button>
                <button @click.prevent="modalGenerateCode = false" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import axios from '../../client'
import Common from '../mixins/Common.vue'
import DatePicker from 'vue2-datepicker'
import Pagination from '../../global/Pagination.vue'
import moment from 'moment'

export default {
  name: 'doctor-clinic-code',
  components: { Pagination, DatePicker },
  mixins: [Common],
  data () {
    return {
      key_search: '',
      isLoading: false,
      dataCodes: [],
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isGeneratingCode: false,
      modalGenerateCode: false,
      dataGenCode: {
        numberOfCode: 1,
        expirationDate: '',
        times: 1,
        do_not_verify_taxonomy: 0,
        allow_sole_proprietor_sign_up_clinic: 0
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      if (!this.isLoading) {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage,
          key: this.key_search,
          type: this.$route.query.type
        }
        this.isLoading = true
        axios.get(`codes/get-list-codes`, { params: params }).then(response => {
          this.isLoading = false
          if (response.data.s === 200) {
            this.dataCodes = response.data.data.codes
            this.paginate.total = response.data.data.total
            this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
          } else {
            this.dataCodes = []
            this.alertError(response.data.msg)
          }
        }).catch(e => {
          this.isLoading = false
          this.alertError('Server error when load data. Press F5 to refresh browser')
        })
      }
    },
    showGenerateCode () {
      this.modalGenerateCode = true
      this.dataGenCode = {
        numberOfCode: 1,
        expirationDate: '',
        times: 1,
        do_not_verify_taxonomy: 0,
        allow_sole_proprietor_sign_up_clinic: 0
      }
    },
    generateCode (number = 10) {
      if (!this.isGeneratingCode) {
        this.isGeneratingCode = true
        this.dataGenCode.type = this.$route.query.type
        this.dataGenCode.expirationDate = this.dataGenCode.expirationDate ? moment(this.dataGenCode.expirationDate).format('MM/DD/YYYY') : ''
        axios.post(`codes/generate-code`,
          this.dataGenCode
        ).then(response => {
          this.isGeneratingCode = false
          if (response.data.s === 200) {
            this.key_search = ''
            this.loadData()
            this.modalGenerateCode = false
            this.dataGenCode = {
              numberOfCode: 1,
              expirationDate: '',
              times: 1,
              do_not_verify_taxonomy: 0,
              all_sole_proprietor_sign_up_clinic: 0
            }
          } else {
            this.alertError(response.data.msg)
          }
        }).catch(e => {
          this.isGeneratingCode = false
          this.alertError('Server error when load data. Press F5 to refresh browser')
        })
      }
    },
    addCode () {
      if (!this.isGeneratingCode && this.key_search) {
        this.isGeneratingCode = true
        axios.post(`codes/add-code`,
          {
            code: this.key_search,
            type: this.$route.query.type
          }
        ).then(response => {
          this.isGeneratingCode = false
          if (response.data.s === 200) {
            this.key_search = ''
            this.loadData()
          } else {
            this.alertError(response.data.msg)
          }
        }).catch(e => {
          this.isGeneratingCode = false
          this.alertError('Server error when load data. Press F5 to refresh browser')
        })
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadData()
    },
    removeItem (dataCode, index) {
      axios.post(`codes/remove-code`,
        {
          code: dataCode.code,
          type: this.$route.query.type
        }
      ).then(response => {
        this.isGeneratingCode = false
        if (response.data.s === 200) {
          this.key_search = ''
          this.loadData()
        } else {
          this.alertError(response.data.msg)
        }
      }).catch(e => {
        this.isGeneratingCode = false
        this.alertError('Server error when load data. Press F5 to refresh browser')
      })
    }
  }
}
</script>

<style>
    .item-taxonomy {
        width: 15% !important;
        min-height: 1px !important;
        text-align: center !important;
    }
    .item-common{
        width: 8% !important;
        min-height: 1px !important;
    }

</style>
